import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "312",
  "slug": "spot-ireland-from-satellite-imagery",
  "title": "How to Recognise Ireland in Satellite Images",
  "excerpt": "The island of Ireland has deeply indented stretches of Atlantic coastline, particularly in the west and southwest.",
  "date": "2026-05-19",
  "category": "Geography",
  "image": "/blog-images/ireland.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "The island of Ireland has deeply indented stretches of Atlantic coastline, particularly in the west and southwest. The long peninsulas around the southwest make better anchors than the green colour of farmland. The east coast faces the Irish Sea and has a different sequence of bays and headlands."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Follow a named peninsula or bay, then compare its orientation with the surrounding coast. Small fields, hedges, and wet uplands also occur in Britain. They cannot reliably separate the islands in an isolated rural crop. This image covers the whole island, including Northern Ireland; visible terrain does not mark the political border."
    }
  ],
  "imageAlt": "Ireland regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
